export const AiTaggingApi = Symbol.for('AiTaggingApi');
